/** In-chat Mitgestalten capture — wedge-filtered feedback for activated users. */

export const FEEDBACK_PROMPT_ID = "feedback-idea";

export const FEEDBACK_CHIP_COOLDOWN_KEY = "albis.feedbackChipCooldownUntil";

export const FEEDBACK_FLOW_TEXT = {
  ask:
    "Was soll Albis anders machen — besonders bei Terminen, Fristen und Erinnerungen?",
  success:
    "Danke — dein Vorschlag steht auf Mitgestalten. Andere Eltern können abstimmen.",
  error:
    "Das Speichern hat gerade nicht geklappt — versuch es auf Mitgestalten nochmal.",
};

export function getFeedbackQuickPrompt() {
  return {
    id: FEEDBACK_PROMPT_ID,
    label: "💬 Verbesserungsvorschlag",
    kind: "feedback",
  };
}

export function canShowFeedbackChip() {
  try {
    const until = localStorage.getItem(FEEDBACK_CHIP_COOLDOWN_KEY);
    if (!until) return true;
    return Date.now() > Number.parseInt(until, 10);
  } catch {
    return true;
  }
}

/** @param {number} [days] */
export function markFeedbackChipCooldown(days = 7) {
  try {
    localStorage.setItem(
      FEEDBACK_CHIP_COOLDOWN_KEY,
      String(Date.now() + days * 24 * 60 * 60 * 1000),
    );
  } catch {
    /* ignore */
  }
}

/** @param {string} text */
export function titleFromFeedbackText(text) {
  const t = String(text || "")
    .trim()
    .replace(/\s+/g, " ");
  if (t.length <= 200) return t;
  return `${t.slice(0, 197)}…`;
}
